import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Image from '@base/FutureImage';
import AllCentreRankersCarousel from './AllCentreRankersCarousel';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  width: 1136px;
  padding-top: ${Spacings.SPACING_10B};
  display: flex;
  flex-direction: column;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const SubTitleContainer = styled.div`
  width: 100%;
  margin-top: ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: row;
  ${mediaQuery.uptoMobile} {
    margin-top: 0px;
    flex-direction: column;
  }
`;

const SubTitleWrapper = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_6};
  align-items: center;
  justify-content: center;
  margin-right: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_3B};
    margin-right: 0px;
  }
`;

const TitleImageContainer = styled.div`
  width: ${Spacings.SPACING_20B};
  height: ${Spacings.SPACING_20B};
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const Subtitle = styled.div`
  color: var(--color-i-black);
  font-size: ${Fonts.LARGE};
  font-weight: ${Fonts.LIGHT};
  line-height: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;

const AllCentreRanker = ({ rankerData }) => {
  const title = rankerData?.title;
  const rankerSubtitle = rankerData?.subtitles;
  const rankerImages = rankerData?.imageUrls;

  return (
    <Wrapper>
      <Container>
        <HeaderContainer>
          <TitleContainer>
            <Typography variant="h2">{title}</Typography>
            <SubTitleContainer>
              {rankerSubtitle.map((data, index) => {
                return (
                  <SubTitleWrapper key={`ranker_subtitle_${index}`}>
                    <Image
                      src="allCentre/subtitleCheckmark.svg"
                      width={20}
                      height={20}
                      alt="Ranker subtitle icon"
                    />
                    <Subtitle>{data}</Subtitle>
                  </SubTitleWrapper>
                );
              })}
            </SubTitleContainer>
          </TitleContainer>
          <TitleImageContainer>
            <Image
              src="allCentre/TopRankersIcon.svg"
              width={80}
              height={80}
              alt="Ranker subtitle icon"
            />
          </TitleImageContainer>
        </HeaderContainer>
        <AllCentreRankersCarousel rankerImages={rankerImages} />
      </Container>
    </Wrapper>
  );
};

export default AllCentreRanker;
